<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
      <p>
        <a class="btn btn-orange btn-icon back" @click="goBack">
          <i class="ti-arrow-left"></i>
          {{ $t('general.back') }}
        </a>
      </p>
      <p class="d-inline-flex">
          <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveMyOrder()" :title="$t('general.save')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
      </p>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
       <div class="modal-header">
          <p>{{ isProcess ? $t('gestiune.processingOrder') : $t('gestiune.addOrder') }}</p>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Comanda pentru locatia</label>
                <select class="form-control" v-model="selectedLocationId" :disabled="isProcess">
                  <option value="" disabled>Selectează locația</option>
                  <optgroup
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :label="`VAT: ${group.vat}`"
                  >
                    <option
                      v-for="loc in group.locations"
                      :key="loc.true_id"
                      :value="loc.true_id"
                    >
                      {{ loc.name }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label>Din locatiile cu gestiune tip depozit</label>
                <select class="form-control" v-model="selectedDepositLocationId" :disabled="isProcess">
                  <option disabled value="">Selectează locația depozit</option>
                  <option
                    v-for="loc in locationsWithDepositGestiune"
                    :key="loc.true_id"
                    :value="loc.true_id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="serie">{{ $t('invoice.series') }}*</label>
                <el-select v-model="myOrder.serie" placeholder="Selectează seria">
                    <el-option
                      v-for="serie in seriesOptions"
                      :key="serie.id"
                      :label="`${serie.name} - ${serie.currentNumber}`"
                      :value="serie.id"
                    ></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="data">{{ $t('gestiune.data') }}</label>
                <el-date-picker
                  v-model="myOrder.date"
                  type="date"
                  placeholder="Selectează data"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('gestiune.gestiune') }}*</th>
              <th>{{ $t('invoice.productName') }}*</th>
              <th>{{ $t('gestiune.codeProduct') }}*</th>
              <th>{{ $t('invoice.unitMeasure') }}*</th>
              <th>{{ $t('gestiune.quantityScriptic') }}*</th>
              <th>{{ $t('gestiune.quantityFaptic') }}*</th>
              <th>Preț fără TVA</th>
              <th>{{ $t('invoice.vatPercent') }}</th>
              <th>{{ $t('invoice.vatValue') }}</th>
              <th>{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- Rânduri deja adăugate -->
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <template v-if="isProcess">
                  <el-select
                    v-model="item.gestiune"
                    placeholder="Selectează gestiunea"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="option in gestiuniForSelectedDepositLocation"
                      :key="option.id"
                      :label="option.name"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else>
                  {{ gestiuneOptions.find(g => g.id === item.gestiune).name || '—' }}
                </template>
              </td>
              <td>{{ typeof item.productName === 'object' ? item.productName.name : item.productName }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.unitMeasure }}</td>
              <td>{{ item.quantity_scriptic }}</td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="item.quantity_faptic"
                  placeholder="Cantitate faptic"
                />
              </td>
              <td>
                <input
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model.number="item.pret_fara_tva"
                  @input="updateVatValue(item)"
                  placeholder="Preț fără TVA"
                />
              </td>
              <td>{{ item.tva_percent }}</td>
              <td>{{ item.vatValue }}</td>
              <td>
                <a class="btn btn-danger btn-icon delete mar-rt-10" @click="removeItem(index)">
                  <img src="/static/img/icons/icon-close.png" />
                  {{ $t('general.delete') }}
                </a>
              </td>
            </tr>

            <!-- Rând de adăugare -->
            <tr>
              <td>
                <el-select v-model="newItem.gestiune" placeholder="Selectează gestiunea">
                  <el-option
                    v-for="option in filteredGestiuni"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
              </td>

              <td style="width: 250px !important;">
                <v-select
                  v-model="newItem.productName"
                  :options="searchResults"
                  label="name"
                  placeholder="Caută un produs..."
                  :filterable="false"
                  @search="fetchProducts"
                  @input="onProductSelected"
                >
                  <template #no-options>
                    <span>Niciun produs găsit</span>
                  </template>
                </v-select>
              </td>

              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="newItem.code"
                  placeholder="Cod"
                  disabled
                />
              </td>

              <td>
                <select v-model="newItem.unitMeasure" class="form-control" disabled>
                   <option :value="newItem.unitMeasure">{{newItem.unitMeasure}}</option>
                </select>
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.quantity_scriptic"
                  :placeholder="$t('gestiune.quantityScriptic')"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.quantity_faptic"
                  :placeholder="$t('gestiune.quantityFaptic')"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.pret_fara_tva"
                  placeholder="Preț fără TVA"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.tva_percent"
                  disabled
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  :value="calculateVatValue(newItem)"
                  disabled
                />
              </td>

              <td>
                <button class="btn btn-primary" @click="addItem">
                  {{ $t('general.add') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import PSwitch from 'src/components/UIComponents/Switch.vue'
import swal from 'sweetalert2'
export default {
  components: {
    PSwitch
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedDepositLocationId: '',
      selectedLocationId: '',
      locations: [],
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      currencyOptions: [
        { code: 'RON', name: 'Leu Românesc (RON)' },
        { code: 'EUR', name: 'Euro (EUR)' },
        { code: 'USD', name: 'Dolar American (USD)' }
      ],
      myOrder: {
        date: new Date(),
        location_id: null,
        gestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        commandProject: ''
      },
      tableData: [],
      isProcess: false,
      items: [],
      newItem: {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 1,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      }
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    this.fetchLocation()
    this.fetchGestiuni()
  },
  watch: {
    selectedLocationId (id) {
      for (const group of this.groupedLocations) {
        const loc = group.locations.find(l => l.true_id === id)
        if (loc) {
          this.selectedLocation = loc

          const { series, number, isProcess } = this.route.query
          this.isProcess = (isProcess === 'true' || isProcess === true)

          if (series && number && this.isProcess && loc.inv_fiscal_code) {
            this.getSeries(loc.inv_fiscal_code)
          }
          break
        }
      }
    },
    locations (newLocations) {
      if (newLocations && newLocations.length) {
        const { series, number, isProcess } = this.route.query
        this.isProcess = (isProcess === 'true' || isProcess === true)
        if (series && number && this.isProcess) {
          this.fetchOrder(series, number)
        }
      }
    }
  },
  computed: {
    groupedLocations () {
      const groups = {}

      if (!this.locations || !this.locations.length) return []

      this.locations.forEach(location => {
        const vat = location.inv_fiscal_code || 'Fără cod fiscal'
        if (!groups[vat]) {
          groups[vat] = []
        }
        groups[vat].push(location)
      })

      const result = Object.entries(groups).map(([vat, locations]) => ({
        vat,
        locations
      }))

      return result
    },
    locationsWithDepositGestiune () {
      if (!Array.isArray(this.gestiuneOptions) || !this.gestiuneOptions.length ||
          !Array.isArray(this.locations) || !this.locations.length) {
        return []
      }

      const locationIdsFromDepositGestiuni = this.gestiuneOptions
        .filter(g => g.is_depozit === true)
        .map(g => g.externalLocationId)

      return this.locations.filter(loc =>
        locationIdsFromDepositGestiuni.includes(loc.true_id)
      )
    },
    gestiuniForSelectedDepositLocation () {
      if (!this.selectedDepositLocationId) return []
      return this.gestiuneOptions.filter(
        g => g.externalLocationId === this.selectedDepositLocationId
      )
    },
    filteredGestiuni () {
      if (!this.selectedLocationId) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocationId
      )
      return result
    }
  },
  methods: {
    resetNewItem () {
      this.newItem = {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 0,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      }
    },
    calculateVatValue (item) {
      const quantity = parseFloat(item.quantity_scriptic) || 0
      const price = parseFloat(item.pret_fara_tva) || 0
      const percent = parseFloat(item.tva_percent) || 0
      const vat = (quantity * price) * percent / 100
      return Number(vat.toFixed(2))
    },
    updateVatValue (item) {
      item.vatValue = this.calculateVatValue(item)
    },
    addItem () {
      const item = {
        ...this.newItem,
        vatValue: this.calculateVatValue(this.newItem)
      }
      this.items.push(item)
      this.resetNewItem()
    },
    removeItem (index) {
      this.items.splice(index, 1)
    },
    async fetchProducts (searchTerm) {
      if (!this.selectedLocation || !searchTerm || searchTerm.length < 2) {
        this.searchResults = []
        return
      }

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?vatNumber=${this.selectedLocation.inv_fiscal_code}&name=${encodeURIComponent(searchTerm)}&externalCompanyId=${this.companyID}`)
        const data = await response.json()

        if (Array.isArray(data.products)) {
          this.searchResults = data.products
        } else {
          this.searchResults = []
        }
      } catch (error) {
        console.error('Error fetching products:', error)
        this.searchResults = []
      }
    },
    onProductSelected (product) {
      if (product && typeof product === 'object') {
        this.newItem.productName = product.name || ''
        this.newItem.code = product.product_code || ''
        this.newItem.unitMeasure = product.um || ''
        this.newItem.tva_percent = product.vat_percent || 0
        this.newItem.pret_fara_tva =
          Array.isArray(product.pret_vanzare) && product.pret_vanzare.length > 0
            ? product.pret_vanzare[0].price
            : 0
      }
    },
    async fetchLocation () {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      }

      this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
        if (!response || response.status !== true || !response.data || !response.data.locations) {
          swal({
            title: 'Eroare!',
            text: response.message || 'Eroare la preluarea locațiilor.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
          return
        }

        this.locations = response.data.locations
      })
    },
    async fetchGestiuni () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
        if (!response.ok) throw new Error('Failed to fetch gestiuni')

        const data = await response.json()
        console.log('Date primite de la server:', data.gestiuni)
        if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
          this.gestiuneOptions = data.gestiuni.map(gest => ({
            id: gest._id,
            name: `${gest.name} (${gest.cod_gestiune})`,
            externalLocationId: gest.externalLocationId || null,
            is_depozit: gest.is_depozit || false
          }))
        } else {
          swal({
            title: 'Error!',
            text: 'Nu s-a primit un array valid de la server.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      } catch (error) {
        swal({
          title: 'Error!',
          text: `Request failed: ${error.message}`,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        console.error('Error fetching management data:', error)
      }
    },
    async getSeries (vatNumber) {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            externalCompanyId: this.companyID,
            vatNumber: vatNumber,
            tip: 'order'
          })
        })

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }

        const data = await response.json()
        console.log('Serii primite:', data.series)

        if (Array.isArray(data.series)) {
          this.seriesOptions = data.series.map(serie => ({
            id: serie._id,
            name: serie.series,
            currentNumber: serie.currentNumber
          }))
        } else {
          console.error('Format invalid pentru series:', data)
        }
      } catch (error) {
        console.error('Error fetching series:', error)
      }
    },
    async saveMyOrder () {
      const missingGestiune = this.items.some(item => !item.gestiune)

      if (missingGestiune) {
        await swal({
          title: 'Atenție',
          text: 'Toate produsele trebuie să aibă selectată o gestiune înainte de a salva comanda.',
          icon: 'warning',
          timer: 2000,
          showConfirmButton: true
        })
        return
      }

      const selectedSerie = this.seriesOptions.find(
        serie => serie.id === this.myOrder.serie || serie.name === this.myOrder.serie
      )
      const serieName = selectedSerie ? selectedSerie.name : this.myOrder.serie || null
      const nextNumber = this.myOrder.currentNumber || 1

      let status = 'new'
      if (this.isProcess) status = 'processed'

      const myOrderData = {
        status,
        products: this.items,
        externalLocationId: this.selectedLocation.true_id,
        vatNumber: this.selectedLocation.inv_fiscal_code,
        externalCompanyId: this.companyID,
        supplierExternalLocationId: this.myOrder.supplierExternalLocationId,
        supplierVatNumber: this.myOrder.supplierVatNumber,
        gestiune: this.myOrder.gestiune || null,
        series: serieName,
        number: nextNumber,
        date: this.myOrder.date ? new Date(this.myOrder.date).toISOString() : new Date().toISOString()
      }

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(myOrderData)
        })

        const data = await response.json()

        if (response.ok) {
          console.log('Comanda salvată cu succes!', data)

          swal({
            title: 'Succes',
            text: 'Comanda a fost salvată cu succes!',
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          })

          // this.router.push('/management/sidebar?tab=ordersSuppliers')

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } else {
          console.error('Eroare la salvarea comenzii', data)

          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la salvarea comenzii.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        }
      } catch (error) {
        console.error('Eroare la trimiterea cererii', error)

        swal({
          title: 'Eroare',
          text: 'A apărut o problemă la trimiterea cererii.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        })
      }
    },
    openAddProductModal () {
      this.$modal.show('addProductModal')
    },
    goBack () {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
      // this.router.go(-1)
    },
    async fetchOrder (series, number) {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order?series=${series}&number=${number}&externalCompanyId=${this.companyID}`)
        if (!response.ok) {
          throw new Error(`Eroare la fetch order: ${response.status}`)
        }

        const data = await response.json()

        console.log('Comandă primită:', data)

        if (data && data) {
          const order = data

          this.myOrder.location_id = order.externalLocationId || null
          this.myOrder.gestiune = order.gestiune || null
          this.myOrder.serie = order.series || null
          this.myOrder.currentNumber = order.number || null
          this.myOrder.supplierVatNumber = order.supplierVatNumber || ''
          this.myOrder.supplierExternalLocationId = order.supplierExternalLocationId || null

          this.items = order.products || []

          if (order.externalLocationId && this.locations && this.locations.length) {
            // Prioritar: caută locația după externalLocationId
            let foundLocation = this.locations.find(loc => loc.true_id === order.externalLocationId)

            // Fallback: dacă nu o găsește, încearcă după vatNumber
            if (!foundLocation && order.vatNumber) {
              foundLocation = this.locations.find(loc => loc.inv_fiscal_code === order.vatNumber)
            }

            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (order.supplierExternalLocationId && this.locationsWithDepositGestiune && this.locationsWithDepositGestiune.length) {
            const foundDepositLocation = this.locationsWithDepositGestiune.find(
              loc => loc.true_id === order.supplierExternalLocationId
            )

            if (foundDepositLocation) {
              this.selectedDepositLocationId = foundDepositLocation.true_id
            }
          }
        } else {
          console.error('Comandă invalidă primită:', data)
          swal({
            title: 'Eroare',
            text: 'Comanda nu a fost găsită.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      } catch (error) {
        console.error('Eroare la fetch order:', error)
        swal({
          title: 'Eroare',
          text: 'A apărut o problemă la încărcarea comenzii.',
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
      }
    }
  }
}
</script>
<style scoped>
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
  min-height: 46px;
  height: 46px;
}
.v-select .dropdown-toggle {
  height: 46px;
}
.btn-primary {
padding: 5px 50px;
}
.el-select,
.el-input {
display: block;
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.table thead tr > th {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/Test.vue